import React, { ComponentProps } from 'react'

import { Player } from './components/organisms/Player'
import { ThemeProvider } from './styled'
import { theme } from './theme'
import './components/atoms/FontAwesomeIcon'

export const GlobisPlayer: React.FC<ComponentProps<typeof Player>> = props => (
  <ThemeProvider theme={theme}>
    <Player {...props} />
  </ThemeProvider>
)
